<template lang="pug">
.btn-group(role="group")
  div(:class="hasTitle ? 'with-title' : ''")
    #slot(ref="slotContainer")
      slot
    #buttons(:class="hasTitle ? 'with-title' : ''" ref="btnContainer")
</template>

<script>
const hasText = item => (item.nodeName === '#text' && item.nodeValue && item.nodeValue !== '↵')

export default {
  name: 'ButtonGroup',
  data: () => ({
    hasTitle: false
  }),
  mounted () {
    this.checkIfHasTitle()
  },
  methods: {
    checkIfHasTitle () {
      this.hasTitle = false
      const slotContainer = this.$refs.slotContainer.$el ? this.$refs.slotContainer.$el : this.$refs.slotContainer
      const childNodes = slotContainer.childNodes
      let item; let clone; let len = childNodes.length
      for (let i = 0; i < len; i++) {
        item = childNodes[i]
        if (item) {
          if (hasText(item) || item.className.indexOf('title') >= 0) {
            this.hasTitle = true
            break
          }
        }
      }
      const btnContainer = this.$refs.btnContainer.$el ? this.$refs.btnContainer.$el : this.$refs.btnContainer
      for (let j = len - 1; j >= 0; j--) {
        item = childNodes[j]
        if (item.nodeName === 'A' || item.nodeName === 'BUTTON') {
          clone = item.cloneNode(true)
          btnContainer.appendChild(clone)
          slotContainer.removeChild(item)
        }
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/styles/variables'
.isMobile .btn-group
  display: none

#buttons
  display: flex
  & a,
  & button
    flex: 1 1 0
.btn-group
  border-radius: $f5px
  z-index: 1000
  & div >>>
    & .asu-title, & .subtitle, & .asu-subtitle
    & button,
    & a
      border: $f1px solid $buttom-info-color
      color: $buttom-info-color
      text-align: center
      font-size: $f16px
      &.router-link-exact-active
        background-color: $buttom-info-color
        color: white
    & .asu-title, & .subtitle, & .asu-subtitle
      background-color: rgba(255, 255, 255, .2)
      border-bottom-width: 0
      border-top-left-radius: $f5px
      border-top-right-radius: $f5px
      cursor: default
      display: block
      font-weight: bold
      padding: $f3px $f8px
    & button,
    & a
      display: inline-block
      background-color: white
      border-left-width: 0
      border-radius: 0
      border-radius: unset
      height: $f28px
      line-height: $f26px
      margin: 0
      padding: 0 $f7px
      min-width: $f80px
      &:first-child
        border-left-width: $f1px
        border-bottom-left-radius: $f5px
      &:nth-of-type(1)
        border-left-width: $f1px
        border-bottom-left-radius: $f5px
      &:last-child
        border-bottom-right-radius: $f5px
    // & a.router-link-active
    //   background-color: $buttom-info-color
    //   color: white
  & div:not(.with-title) >>>
    & button,
    & a
      &:first-child
        border-top-left-radius: $f5px
      &:last-child
        border-top-right-radius: $f5px

</style>
